import { fvDate } from '@fv/dates'
import type { Workflow } from '@fv/models'
import { equipmentTypes } from '@fv/models/equipment'

const parseField = (field: string, value: string) => {
  if (field.match(/dateType|shipType|packagingType|country/i) && value) {
    return value.toLowerCase()
  }

  if (
    field.match(
      /weight|height|width|length|quantity|maxTemp|minTemp|count|size|sequence/i,
    )
  ) {
    const int = parseInt(value)

    if (isNaN(int)) {
      return undefined
    }

    return int
  }

  if (field.match(/date/i) && value) {
    return fvDate(value).format('YYYY-MM-DD')
  }

  if (field.match(/flag/i)) {
    return !!value && !value.match(/false|no/i)
  }

  if (field.match(/equipmenttype/i) && value) {
    const normalizedValue = value.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase()

    return (
      equipmentTypes.find(e => e.key.startsWith(normalizedValue))?.key || value
    )
  }

  if (field.match(/freightclass|declaredValue|price/i) && value) {
    const float = parseFloat(value)

    if (isNaN(float)) {
      return undefined
    }

    return float
  }

  if (!value) {
    return undefined
  }

  return value
}

export const parseShipmentCsv = async (file: File) => {
  const { parseCSVFile } = await import('@/utils/parse')
  const csvData = await parseCSVFile(file)
  return csvData.map(d =>
    Object.fromEntries(
      Object.entries(d).map(([key, value]) => [key, parseField(key, value)]),
    ),
  )
}

export function buildUploadName(workflow?: Workflow): string {
  const now = fvDate()
  const workflowPrefix = workflow ? `${workflow}_` : ''
  return `${workflowPrefix}${now.format('YYMMDD')}_${now.format('HHmm')}`
}

export const CONFIRM_UPLOAD_EXIT = `You haven't completed your upload.  Are you sure you want to cancel?`
